__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "plurall-user-account";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@plurall/client", "5.1.1", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(224), __webpack_require__.e(852), __webpack_require__.e(418)]).then(() => (() => (__webpack_require__(51852))))));
			register("@plurall/elo-beta", "2.0.0-beta.524", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(977), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(444), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(57594))))));
			register("@plurall/widget-teacher-classes", "1.0.36", () => (Promise.all([__webpack_require__.e(684), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(36684))))));
			register("@sentry/react", "7.120.4", () => (Promise.all([__webpack_require__.e(224), __webpack_require__.e(721), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(77721))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("dompurify", "3.4.17", () => (__webpack_require__.e(37).then(() => (() => (__webpack_require__(99418))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(150), __webpack_require__.e(396), __webpack_require__.e(678)]).then(() => (() => (__webpack_require__(62678))))));
			register("graphql-tag", "2.12.6", () => (Promise.all([__webpack_require__.e(150), __webpack_require__.e(396), __webpack_require__.e(893)]).then(() => (() => (__webpack_require__(85893))))));
			register("graphql-tag", "2.12.7", () => (Promise.all([__webpack_require__.e(150), __webpack_require__.e(396), __webpack_require__.e(135)]).then(() => (() => (__webpack_require__(2135))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(55894);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};